<template>
  <div class="re-book text-center mb-16">
    <h1 class="dastnevis py-5">کتاب داستان: {{ book.title }}</h1>
    <v-chip label class="px-5"> موضوع: {{ book.moralvalue }} </v-chip>
    <div v-if="book" class="my-5">
      <v-img
        contain
        class="re-rounded re-shadow mx-auto"
        elevation="10"
        width="250"
        :src="
          'https://dl.pirls.ir/app/bookcovers/' + this.$route.params.id + '.jpg'
        "
      />
    </div>
    <div class="text--caption pb-2">
      <div class="re-description mx-auto">
        {{ book.description }}
      </div>
    </div>
    <MenuComponent :book-id="this.$route.params.id" state />
  </div>
</template>
<script>
import MenuComponent from "../components/Books/Menu.vue";
export default {
  name: "book-component",
  components: { MenuComponent },
  data() {
    return {
      book: {}
    };
  },
  created() {
    this.getBook();
  },
  methods: {
    getBook() {
      const apiUrl = "/book/" + this.$route.params.id;
      this.$api.get(apiUrl).then((res) => {
        this.book = res.data.book;
      });
    }
  }
};
</script>
